import ServiceLocator from "../../../../domain/service-locator";

/**
 * 現在の言語に基づいて適切なフォントクラスを取得する関数
 * @returns フォントクラス名
 */
export const getLanguageBasedFontClass = (): string => {
  try {
    const languageRepository = ServiceLocator.LanguageRepository;
    const currentLanguageId = languageRepository.currentLanguageId.watch();
    const languages = languageRepository.languages;

    // 現在の言語情報を取得
    const currentLanguage = languages.find((lang) =>
      lang.id === currentLanguageId
    );

    if (!currentLanguage) {
      // フォールバック: 言語が見つからない場合はBradford LLフォントを使用
      return "font-bradford-ll";
    }

    // localeIdに基づいてフォントを決定
    // 日本語の場合はNoto Serif JP、その他の場合はBradford LL
    if (currentLanguage.localeId?.startsWith("ja")) {
      return "font-noto-serif-jp";
    } else {
      return "font-bradford-ll";
    }
  } catch (error) {
    console.warn("Error determining font class:", error);
    // エラー時のフォールバック
    return "font-bradford-ll";
  }
};

/**
 * React hooks用の言語ベースフォントクラス取得カスタムフック
 * @returns フォントクラス名
 */
export const useLanguageBasedFont = (): string => {
  try {
    const languageRepository = ServiceLocator.LanguageRepository;
    const currentLanguageId = languageRepository.currentLanguageId.watch();
    const languages = languageRepository.languages;

    const currentLanguage = languages.find((lang) =>
      lang.id === currentLanguageId
    );

    if (!currentLanguage) {
      return "font-bradford-ll";
    }

    if (currentLanguage.localeId?.startsWith("ja")) {
      return "font-noto-serif-jp";
    } else {
      return "font-bradford-ll";
    }
  } catch (error) {
    console.warn("Error in useLanguageBasedFont:", error);
    return "font-bradford-ll";
  }
};
